<template>
    <div class="home">
        <section class="hero" id="home">
            <!-- <h1 class="fade-in-slide-up">Welcome to Dubai Exotics</h1> -->
            <h1 id="custom-typing-animation">{{ typedText }}<span class="blinking-caret" v-if="showCaret"></span></h1>
            <p class="fade-in">Experience the thrill of what Dubai has to offer and much more.</p>
            <!-- <button class="btn btn-primary" @click.prevent="scrollToSection('fleet')">View Cars</button> -->
        </section>

        <!-- Renting Made Easy Section -->
        <section class="renting-steps" id="services">
            <h3 :style="scaledServicesStyle">Services We Offer</h3> <!-- Scaling based on scroll -->
            <div class="steps-carousel" ref="carousel">
                <div v-for="(service, index) in services" :key="index" class="service-section">
                    <!-- Text explicitly positioned outside of the video container -->

                    <!-- Video as the main content -->
                    <div class="video-wrapper" ref="videoWrapper">
                        <video ref="serviceVideos" :src="service.videoUrl" muted autoplay loop playsinline
                            :style="videoStyle(index)">
                        </video>
                    </div>
                    <div class="service-info">
                        <h3 class="service-title">{{ service.title }}</h3>
                        <p class="service-description">{{ service.description }}</p>
                    </div>
                    <hr class="mobile-divider" />

                </div>
            </div>
        </section>


        <section class="featured-cars" id="fleet">
            <div style="padding: 10px;"></div>
            <h2>Our Exotic Fleet</h2>
            <div class="currency-selector">

                <label for="currency" class="currency-label">Select Currency:</label>
                <select v-model="selectedCurrency" class="currency-dropdown">
                    <option value="AED">AED</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="GBP">GBP</option>
                </select>
            </div>



            <div class="carousel" ref="carousel">
                <div v-for="(car, index) in convertedCars" :key="index"
                    :class="['car-listing', { active: currentIndex === index }]" @mouseenter="handleMouseEnter(index)">

                    <!-- Video autoplay and pause logic -->
                    <template v-if="car.video">
                        <video ref="carVideos" :src="car.video" muted autoplay loop playsinline>
                            Your browser does not support the video tag.
                        </video>
                    </template>
                    <template v-else>
                        <img :src="car.img" :alt="car.name" />
                    </template>

                    <!-- Car details including converted price -->
                    <div class="car-details">
                        <h3>{{ car.name }}</h3>
                        <p>{{ car.convertedPrice }} {{ selectedCurrency }} /Day</p> <!-- Price Display -->
                    </div>

                    <button class="btn btn-secondary" @click="redirectToWhatsApp">
                        <!-- WhatsApp SVG Icon -->
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                            style="vertical-align: middle; margin-right: 8px;">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M12.0487 22.8569H12.044C10.1393 22.8562 8.26768 22.3823 6.60539 21.4832L0.572266 23.0526L2.18683 17.2044C1.19089 15.4929 0.666829 13.5514 0.667683 11.5623C0.670179 5.33985 5.7756 0.277344 12.0486 0.277344C15.0931 0.278647 17.9506 1.45396 20.0992 3.58719C22.2479 5.72032 23.4306 8.55577 23.4294 11.5713C23.4269 17.7923 18.3235 22.8543 12.0487 22.8569ZM6.88556 19.4402L7.23097 19.6434C8.6833 20.4981 10.3481 20.9503 12.0455 20.951H12.0493C17.263 20.951 21.5064 16.7429 21.5085 11.5707C21.5094 9.06423 20.5265 6.70752 18.7406 4.93446C16.9546 3.16139 14.5796 2.18446 12.0531 2.18359C6.83536 2.18359 2.59191 6.39122 2.58984 11.5631C2.58911 13.3355 3.08921 15.0616 4.0361 16.5551L4.26101 16.91L3.30542 20.3715L6.88556 19.4402ZM17.3926 14.0021C17.591 14.0971 17.7249 14.1613 17.7821 14.256C17.8531 14.3736 17.8531 14.9382 17.6163 15.597C17.3792 16.2557 16.2432 16.8568 15.6968 16.9378C15.2069 17.0104 14.5869 17.0407 13.9057 16.826C13.4927 16.6961 12.963 16.5226 12.2846 16.232C9.6187 15.0905 7.81711 12.5283 7.47661 12.044C7.45276 12.0101 7.43608 11.9864 7.42677 11.974L7.42447 11.971C7.27398 11.7719 6.26562 10.4377 6.26562 9.05693C6.26562 7.758 6.90905 7.07717 7.20522 6.76378C7.22552 6.74231 7.24418 6.72256 7.26089 6.70446C7.52154 6.42214 7.82964 6.35156 8.0192 6.35156C8.20875 6.35156 8.39853 6.3533 8.56422 6.36155C8.58466 6.36257 8.60593 6.36245 8.62791 6.36232C8.79362 6.36135 9.00022 6.36015 9.20403 6.84562C9.28244 7.03246 9.39717 7.30945 9.51818 7.60159C9.76287 8.19232 10.0332 8.84499 10.0808 8.93944C10.1519 9.0806 10.1993 9.24521 10.1045 9.4335C10.0903 9.46173 10.0771 9.48837 10.0645 9.51383C9.99333 9.65796 9.94096 9.76398 9.82013 9.90388C9.77262 9.9589 9.72351 10.0182 9.6744 10.0775C9.57657 10.1957 9.47875 10.3138 9.39357 10.3979C9.25121 10.5386 9.10301 10.6911 9.26889 10.9734C9.43477 11.2558 10.0055 12.1792 10.8509 12.9269C11.7596 13.7307 12.5494 14.0704 12.9497 14.2426C13.0279 14.2763 13.0912 14.3035 13.1377 14.3266C13.422 14.4678 13.5878 14.4441 13.7537 14.256C13.9196 14.0678 14.4646 13.4325 14.6541 13.1503C14.8437 12.8681 15.0333 12.9151 15.2939 13.0091C15.5547 13.1033 16.9527 13.7854 17.2371 13.9266C17.2926 13.9541 17.3445 13.979 17.3926 14.0021Z"
                                fill="#FDFDFD" />
                        </svg>
                        WhatsApp
                    </button>
                </div>

            </div>
        </section>

        <!-- Renting Made Easy Section -->
        <section class="renting-steps-dreams" data-aos="fade-up">
            <h2>Turning Dreams into Reality</h2>
            <h3>Your Perfect Experience is a Few Steps Away</h3>
            <div class="steps-dreams">
                <div class="step-dreams" data-aos="fade-up" data-aos-delay="200">
                <div class="step-number-dreams">1</div>
                <h4>Choose your Experience</h4>
                <p>Let us know what you would like to do and we take care of the rest</p>
                </div>
                <div class="step-dreams" data-aos="fade-up" data-aos-delay="400">
                <div class="step-number-dreams">2</div>
                <h4>Pick dates and time</h4>
                <p>We will set everything up that fits your needs.</p>
                </div>
                <div class="step-dreams" data-aos="fade-up" data-aos-delay="600">
                <div class="step-number-dreams">3</div>
                <h4>Let the journey begin</h4>
                <p>Complete the booking process with our rep and you are all set.</p>
                </div>
            </div>
        </section>

        <!-- Why Choose Us Section -->
        <section class="why-choose-us" id="why-choose-us">
            <h2>Why Choose Dubai Exotics?</h2>
            <div class="benefits">
                <div class="benefit" data-aos="flip-up" data-aos-delay="700">
                    <div class="benefit-icon">
                        <img src="@/assets/reservation_10337087.png" alt="Contactless Checkin">
                    </div>
                    <h4>Effortless Check-In</h4>
                    <p>We simply the process to ensure no BS or Headaches.</p>
                </div>
                <div class="benefit" data-aos="flip-up" data-aos-delay="900">
                    <div class="benefit-icon">
                        <img src="@/assets/balance_8946365.png" alt="Competitive Pricing">
                    </div>
                    <h4>Fair Pricing</h4>
                    <p>Enjoy the best experience at the best prices, we want you to be happy.</p>
                </div>
                <div class="benefit" data-aos="flip-up" data-aos-delay="1100">
                    <div class="benefit-icon">
                        <img src="@/assets/rating_11683606.png" alt="Customer Support">
                    </div>
                    <h4>Customer Care</h4>
                    <p>A team of english speaking reps who will always go the extra mile for you.</p>
                </div>
                <div class="benefit" data-aos="flip-up" data-aos-delay="1200">
                    <div class="benefit-icon">
                        <img src="@/assets/trustworthy_12072574.png" alt="Safety and Reliability">
                    </div>
                    <h4>Reliability</h4>
                    <p>From start to finish your our top priority and always a message away to help.</p>
                </div>
            </div>
        </section>
        <section class="faq-section" id="faq">
            <h2>Frequently Asked Questions</h2>
            <div class="faq-grid">
                <div 
                    class="faq-item" 
                    v-for="(faq, index) in (showAll ? faqs : faqs.slice(0, 5))" 
                    :key="index" 
                    :class="{
                        'faq-item-even': index % 2 === 0,
                        'faq-item-odd': index % 2 === 1,
                    }"
                >
                    <div class="faq-question" @click="toggleFAQ(index)">
                        <span class="faq-text">{{ faq.question }}</span>
                        <span class="faq-toggle" :class="{ active: activeFAQ === index }">+</span>
                    </div>
                    <transition name="slide-fade" @enter="enter" @leave="leave">
                        <div v-if="activeFAQ === index" class="faq-answer">
                            {{ faq.answer }}
                        </div>
                    </transition>
                </div>
            </div>
            <!-- Show More and Show Less Buttons -->
            <button v-if="!showAll" @click="toggleFAQs" class="show-more-btn">Show More</button>
            <button v-if="showAll" @click="toggleFAQs" class="show-less-btn">Show Less</button>
        </section>

        <!-- Floating WhatsApp Button -->
        <div class="floating-whatsapp" @click="redirectToWhatsApp">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                            style="vertical-align: middle; margin-right: 8px;">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M12.0487 22.8569H12.044C10.1393 22.8562 8.26768 22.3823 6.60539 21.4832L0.572266 23.0526L2.18683 17.2044C1.19089 15.4929 0.666829 13.5514 0.667683 11.5623C0.670179 5.33985 5.7756 0.277344 12.0486 0.277344C15.0931 0.278647 17.9506 1.45396 20.0992 3.58719C22.2479 5.72032 23.4306 8.55577 23.4294 11.5713C23.4269 17.7923 18.3235 22.8543 12.0487 22.8569ZM6.88556 19.4402L7.23097 19.6434C8.6833 20.4981 10.3481 20.9503 12.0455 20.951H12.0493C17.263 20.951 21.5064 16.7429 21.5085 11.5707C21.5094 9.06423 20.5265 6.70752 18.7406 4.93446C16.9546 3.16139 14.5796 2.18446 12.0531 2.18359C6.83536 2.18359 2.59191 6.39122 2.58984 11.5631C2.58911 13.3355 3.08921 15.0616 4.0361 16.5551L4.26101 16.91L3.30542 20.3715L6.88556 19.4402ZM17.3926 14.0021C17.591 14.0971 17.7249 14.1613 17.7821 14.256C17.8531 14.3736 17.8531 14.9382 17.6163 15.597C17.3792 16.2557 16.2432 16.8568 15.6968 16.9378C15.2069 17.0104 14.5869 17.0407 13.9057 16.826C13.4927 16.6961 12.963 16.5226 12.2846 16.232C9.6187 15.0905 7.81711 12.5283 7.47661 12.044C7.45276 12.0101 7.43608 11.9864 7.42677 11.974L7.42447 11.971C7.27398 11.7719 6.26562 10.4377 6.26562 9.05693C6.26562 7.758 6.90905 7.07717 7.20522 6.76378C7.22552 6.74231 7.24418 6.72256 7.26089 6.70446C7.52154 6.42214 7.82964 6.35156 8.0192 6.35156C8.20875 6.35156 8.39853 6.3533 8.56422 6.36155C8.58466 6.36257 8.60593 6.36245 8.62791 6.36232C8.79362 6.36135 9.00022 6.36015 9.20403 6.84562C9.28244 7.03246 9.39717 7.30945 9.51818 7.60159C9.76287 8.19232 10.0332 8.84499 10.0808 8.93944C10.1519 9.0806 10.1993 9.24521 10.1045 9.4335C10.0903 9.46173 10.0771 9.48837 10.0645 9.51383C9.99333 9.65796 9.94096 9.76398 9.82013 9.90388C9.77262 9.9589 9.72351 10.0182 9.6744 10.0775C9.57657 10.1957 9.47875 10.3138 9.39357 10.3979C9.25121 10.5386 9.10301 10.6911 9.26889 10.9734C9.43477 11.2558 10.0055 12.1792 10.8509 12.9269C11.7596 13.7307 12.5494 14.0704 12.9497 14.2426C13.0279 14.2763 13.0912 14.3035 13.1377 14.3266C13.422 14.4678 13.5878 14.4441 13.7537 14.256C13.9196 14.0678 14.4646 13.4325 14.6541 13.1503C14.8437 12.8681 15.0333 12.9151 15.2939 13.0091C15.5547 13.1033 16.9527 13.7854 17.2371 13.9266C17.2926 13.9541 17.3445 13.979 17.3926 14.0021Z"
                                fill="#FDFDFD" />
                        </svg>
        Contact Us
        </div>

    </div>
</template>

<script>
import AOS from 'aos';
import 'aos/dist/aos.css';


export default {
    name: 'AppHome',
    data() {
        return {
            fullText: "Welcome to Dubai Exotics",
            typedText: "",
            typingSpeed: 100, // Speed in milliseconds
            showCaret: true,
            activeFAQ: null,
            showAll: false,
            currentIndexServices: 0,
            currentIndex: 0,
            scrollY: 0,
            cars: [
                { img: require('@/fleet/lamb.png'), name: 'Lamborghini Urus', price: 3000, 'video': require('@/fleet/lamb-urus.mp4') },
                { img: require('@/fleet/lamb.png'), name: 'Lamborghini Aventador Roadster', price: '6000', 'video': require('@/fleet/lamb-hurcan-spyder.mp4') },
                { img: require('@/fleet/lamb.png'), name: 'Rolls-Royce Cullinan', price: '4000', 'video': require('@/fleet/rolls-cullinan.mp4') },
                { img: require('@/fleet/lamb.png'), name: 'McLaren 570S', price: '3000', 'video': require('@/fleet/mclaren-570s.mp4') },
                { img: require('@/fleet/lamb.png'), name: 'Bentley Bentayga', price: '2500', 'video': require('@/fleet/bent-bentayga.mp4') },
                { img: require('@/fleet/lamb.png'), name: 'Mercedes G63', price: '3000', 'video': require('@/fleet/merc-g-63.mp4') },
                { img: require('@/fleet/lamb.png'), name: 'Cadillac Escalade', price: '1500', 'video': require('@/fleet/cadllac-escalade.mp4') },
                { img: require('@/fleet/lamb.png'), name: 'Rolls-Royce Dawn', price: '3500', 'video': require('@/fleet/rolls-dawn.mp4') },
            ],
            services: [
                {
                    title: "Exotic Cars",
                    description: "We offer a wide range of luxury Cars or SUVs for your needs.",
                    videoUrl: require('@/services/cars.mp4')// Add video URLs
                },
                {
                    title: "Exotic Animals",
                    description: "From baby Lions to Bears and everything in between we can ensure you a memorable experience.",
                    videoUrl: require('@/services/animals.mp4')
                },
                {
                    title: "Luxury Yachts",
                    description: "Spend the day or a few hours on water capturing Dubais beauty from a different angle. We offer a wide range of yacht selections.",
                    videoUrl: require('@/services/yachts.mp4')
                }
            ],
            selectedCurrency: 'AED',
            conversionRates: {
                AED: 1,
                USD: 0.27,
                EUR: 0.23,
                GBP: 0.20
            },
            faqs: [
                {
                    question: "What is the age limit to rent a vehicle from Dubai Exotics?",
                    answer: "You must be between 21- 65 years old and hold a valid driver's license."
                },
                {
                    question: "What documents do I need to rent a vehicle?",
                    answer: "Credit Card, Passport, Valid UAE/ Valid International License."
                },
                {
                    question: "Is a Deposit required to rent a vehicle?",
                    answer: "Yes, we require a small deposit."
                },
                {
                    question: "How do I pay?",
                    answer: "Visa, American Express, CryptoCurrency, Cash."
                },
                {
                    question: "Can I cancel my booking?",
                    answer: "Yes, you can cancel up to 48 hours prior to your booking free of charge. Fees will apply within 48 hours."
                },
                {
                    question: "Late Fees",
                    answer: "Each rental is 24 hours, if the vehicle is not returned in a timely manner you could be charged for an extra day."
                },
                {
                    question: "Where do I pick up the vehicle?",
                    answer: "We will drop off your rental at any location you wish."
                },
                {
                    question: "Extending my rental as an option?",
                    answer: "Yes, you can always extend, but if the vehicle is already booked by another client you can exchange and pick another vehicle."
                },
                {
                    question: "Roadside assistance offered?",
                    answer: "Contact us on whatsapp right away and we will find a solution. Never leave your vehicle."
                },
                {
                    question: "How do I book?",
                    answer: "Contact us on whatsapp."
                },
                {
                    question: "What should I do if the vehicle is damaged or involved in an accident?",
                    answer: "Contact the police right away and make a report, contact us on whatsapp and inform us of the problem so we can better help you with the process."
                },
                {
                    question: "Any other charges applicable?",
                    answer: "No hidden fees, No BS, just enjoy your time."
                },
                {
                    question: "What happens if I get tickets during my rental period?",
                    answer: "You will be 100% responsible to pay for all speeding tickets, traffic violations or anything of the sorts."
                },
                {
                    question: "Do I pay for tolls?",
                    answer: "Yes, you will be responsible to cover all tolls and fees associated."
                },
                // Add more FAQs as needed...
            ],
            videoPlayed: [],
            serviceVideos: [],
        };
    },
    mounted() {
        this.typeText();
        AOS.init({
            offset: 600, // Trigger animations when the element is 200px from the top of the viewport
            duration: 1000, // Animation duration in milliseconds
            easing: 'ease-in-out', // Animation easing
            once: true, // Animation should happen only once - while scrolling down
            delay: 100, // Delay between each element's animation
        });
        this.updateNeighbors();
        const carousel = this.$refs.carousel;
        carousel.addEventListener('scroll', this.onScroll);
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleScroll);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll); // Clean up event listener
        window.removeEventListener('resize', this.handleScroll);
    },
    watch: {
        currentIndex(newIndex, oldIndex) {
            // Pause the video in the old index and play the video in the new index
            const videos = this.$refs.carVideos;

            if (videos[oldIndex]) {
                videos[oldIndex].pause(); // Pause the previous video
            }
            if (videos[newIndex]) {
                videos[newIndex].play(); // Play the new active video
            }
        },
        currentIndexServices(newIndex, oldIndex) {
            const videos = this.$refs.serviceVideos;

            if (videos[oldIndex]) {
                videos[oldIndex].pause();
                videos[oldIndex].src = ''; // Stop the previous video completely
            }

            if (videos[newIndex]) {
                videos[newIndex].play().catch(error => {
                    console.log('Error playing video:', error);
                });
            }
        },
    },
    // created() {
    //     this.startWelcomeAnimation();
    // },
    computed: {
        // videoStyle() {
        //     const isMobile = window.innerWidth <= 768;
        //     const scrollStart = 50; // Change this to when you'd like videos to start fading in
        //     const opacityFactor = isMobile ? 100 : 400; // Adjust based on screen size

        //     // Calculate opacity for videos
        //     const opacity = Math.min(0.3 + Math.max(this.scrollY - scrollStart, 0) / opacityFactor, 1);
        //     const scale = Math.min(1 + Math.max(this.scrollY - scrollStart, 0) / 100, 1.1);

        //     return {
        //         opacity: opacity,
        //         transform: `scale(${scale})`,
        //         transition: 'opacity 0.5s ease, transform 0.5s ease'
        //     };
        // },
        isDesktop() {
            return window.innerWidth > 768; // Simple check for desktop
        },
        convertedCars() {
            // Convert the car prices based on selectedCurrency
            return this.cars.map(car => {
                const price = parseFloat(car.price) * this.conversionRates[this.selectedCurrency];
                const convertedPrice = Number(price.toFixed(0)).toLocaleString(); // Add comma separators
                return {
                    ...car,
                    convertedPrice: convertedPrice // Add convertedPrice to each car object
                };
            });
        },
        scaledServicesStyle() {
            const isMobile = window.innerWidth <= 768;
            const scrollStart = isMobile ? 0 : 0;

            // Further increase scaleFactor and opacityFactor for a slower transition
            const scaleFactor = isMobile ? 100 : 150; // Much slower scaling
            const opacityFactor = isMobile ? 150 : 200; // Much slower opacity change

            // Calculate the font size scaling factor based on scroll position
            const fontSizeScale = Math.min(1 + Math.max(this.scrollY - scrollStart, 0) / scaleFactor, 2);
            const opacity = Math.min(0.3 + Math.max(this.scrollY - scrollStart, 0) / opacityFactor, 1);

            return {
                fontSize: `${fontSizeScale}em`, // Adjust the font size dynamically
                opacity: opacity,
            };
        },

    },
    methods: {
        typeText() {
            let index = 0;
            const typeNextChar = () => {
                if (index < this.fullText.length) {
                this.typedText += this.fullText.charAt(index);
                index++;
                setTimeout(typeNextChar, this.typingSpeed);
                } else {
                // Show caret only after typing is done
                setTimeout(() => {
                    this.showCaret = true;
                }, 500);
                }
            };
            typeNextChar();
        },
        redirectToWhatsApp() {
            const message = encodeURIComponent("I'm interested in one of your services, can you give me more information?");
            window.open(`https://wa.me/971526694811?text=${message}`, '_blank');
        },
        scrollToSection(sectionId) {
            const section = document.getElementById(sectionId);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        },
        handleScroll() {
            this.scrollY = window.scrollY; // Track the scroll position
        },
        titleStyle(index) {
            const start = this.isDesktop ? window.innerHeight / 4 : index * (window.innerHeight / 2); // Start earlier on desktop
            const fadeIn = Math.min((this.scrollY - start) / 100, 1);
            return {
                opacity: fadeIn,
                transform: `translateY(${(1 - fadeIn) * 20}px)`,
                transition: 'opacity 0.4s ease, transform 0.4s ease'
            };
        },
        descriptionStyle(index) {
            const start = this.isDesktop ? window.innerHeight / 4 + 50 : index * (window.innerHeight / 2) + 50;
            const fadeIn = Math.min((this.scrollY - start) / 100, 1);
            return {
                opacity: fadeIn,
                transform: `translateY(${(1 - fadeIn) * 20}px)`,
                transition: 'opacity 0.4s ease, transform 0.4s ease'
            };
        },
        videoStyle(index) {
            const start = 10;
            const fadeIn = Math.min((this.scrollY - start) / 40, 1);

            if (fadeIn === 1) {
                this.videoPlayed[index] = true;
                // this.updateParentHeight(index); // Update parent height when the video is fully visible
            }

            return {
                paddingTop: '20px',
                opacity: this.videoPlayed[index] ? 1 : fadeIn,
                transition: 'opacity 1.5s ease',
                maxHeight: '600px'
            };
        },
        updateParentHeight(index) {
            this.$nextTick(() => {
                // Check if this.$refs.videoWrapper is defined and access the element at the specified index
                if (this.$refs.videoWrapper && this.$refs.videoWrapper[index]) {
                    const videoWrapper = this.$refs.videoWrapper[index];
                    const videoElement = this.$refs.serviceVideos?.[index];

                    if (videoElement) {
                        // Get the natural dimensions of the video to maintain the aspect ratio
                        const videoNaturalWidth = videoElement.videoWidth;
                        const videoNaturalHeight = videoElement.videoHeight;

                        // Get the current width of the video container
                        const currentWidth = videoWrapper.clientWidth;

                        // Calculate the new height based on the aspect ratio
                        const aspectRatio = videoNaturalHeight / videoNaturalWidth;
                        
                        // Calculate the scaled height to fit within the current width of the video wrapper
                        const scaledHeight = currentWidth * aspectRatio;

                        // Set the height of the video wrapper
                        console.log('video height set again');
                        videoWrapper.style.height = `${scaledHeight - 100}px`;

                        // Force height update on the parent container if necessary
                        this.forceParentHeightUpdate(videoWrapper);
                    }
                } else {
                    console.error(`Video wrapper or video element not found for index: ${index}`);
                }
            });
        },
        forceParentHeightUpdate(element) {
            // Traverse up the DOM tree and ensure all parent elements have auto height
            let parent = element.parentElement;
            while (parent) {
                parent.style.height = 'auto';
                parent = parent.parentElement;
            }
        },
        videoBackgroundStyle(index) {
            const start = this.isDesktop ? window.innerHeight / 6 : (index + 1) * (window.innerHeight / 6);
            const showVideo = Math.max(Math.min((this.scrollY - start) / 15, 1), 0);

            return {
                // zIndex: this.videoPlayed[index] || showVideo >= 1 ? 0 : -1,
                position: 'absolute',
                width: '100%',
                height: '100%',
                opacity: this.videoPlayed[index] ? 1 : showVideo,
                transition: 'opacity 1.5s ease',
                pointerEvents: showVideo >= 1 || this.videoPlayed[index] ? 'auto' : 'none'
            };
        },
        startWelcomeAnimation() {
            let index = 5; // Starting from index 5

            const interval = setInterval(() => {
                if (index >= 0) {
                    this.setActive(index); // Set active index
                    index--; // Move to the previous index
                } else {
                    clearInterval(interval); // Stop the animation when done
                }
            }, 1000); // Adjust the delay as needed (1000ms = 1 second)
        },
        setActive(index) {
            this.currentIndex = index;
            this.updateNeighbors();
        },
        updateNeighbors() {
            const carousel = this.$refs.carousel;
            const cards = carousel.children;

            // Clear previous and next classes
            for (let i = 0; i < cards.length; i++) {
                cards[i].classList.remove('previous', 'next');
            }

            // Set previous and next based on the active index
            if (this.currentIndex > 0) {
                cards[this.currentIndex - 1].classList.add('previous');
            }
            if (this.currentIndex < cards.length - 1) {
                cards[this.currentIndex + 1].classList.add('next');
            }
        },
        changeCurrency(currency) {
            this.selectedCurrency = currency;
        },
        nextSlide() {
            this.currentIndex = (this.currentIndex + 1) % this.cars.length;
            this.setActive(this.currentIndex);
        },
        prevSlide() {
            this.currentIndex = (this.currentIndex - 1 + this.cars.length) % this.cars.length;
            this.setActive(this.currentIndex);
        },
        scrollToActive(callback) {
            const carousel = this.$refs.carousel;
            const activeCard = carousel.children[this.currentIndex];
            const cardWidth = activeCard.offsetWidth;
            const carouselCenter = carousel.offsetWidth / 2;
            const cardCenter = activeCard.offsetLeft + cardWidth / 2;

            carousel.scrollTo({
                left: cardCenter - carouselCenter,
                behavior: 'smooth'
            });

            // Use a small timeout to trigger the callback after the scrolling finishes
            setTimeout(() => {
                if (typeof callback === 'function') {
                    callback();
                }
            }, 20); // Adjust timing to ensure smooth scroll completes
        },
        onScroll() {
            const carousel = this.$refs.carousel;
            const cards = Array.from(carousel.children);
            const carouselCenter = carousel.offsetWidth / 2;

            let closestIndex = 0;
            let minDistance = Infinity;

            // Detect which card is closest to the center of the carousel
            cards.forEach((card, index) => {
                const cardCenter = card.offsetLeft + card.offsetWidth / 2;
                const distance = Math.abs(carouselCenter - (cardCenter - carousel.scrollLeft));

                if (distance < minDistance) {
                    minDistance = distance;
                    closestIndex = index;
                }
            });

            this.currentIndex = closestIndex;
            this.updateNeighbors(); // Update previous/next states
        },
        handleMouseEnter(index) {
            if (window.innerWidth > 768) {  // Only run hover logic on desktop
                this.setActive(index);
            }
        },
        handleMouseEnterService(index) {
            this.currentIndexServices = index; // Set the active index for services when the user interacts
        },
        toggleFAQ(index) {
            this.activeFAQ = this.activeFAQ === index ? null : index;
        },
        toggleFAQs() {
            this.showAll = !this.showAll; // Toggle between showing all and only the first 5
        },
        enter(el) {
            el.style.height = '0';
            el.style.opacity = '0';
            el.style.paddingTop = '0';
            el.offsetHeight; // trigger reflow
            el.style.transition = 'all 0.3s ease';
            el.style.height = el.scrollHeight + 'px';
            el.style.opacity = '1';
            el.style.paddingTop = '10px';
        },
        leave(el) {
            el.style.height = el.scrollHeight + 'px';
            el.style.opacity = '1';
            el.style.paddingTop = '10px';
            el.offsetHeight; // trigger reflow
            el.style.transition = 'all 0.3s ease';
            el.style.height = '0';
            el.style.opacity = '0';
            el.style.paddingTop = '0';
        },
    }
}
</script>

<style scoped>
.home {
    text-align: center;

}

/* Carousel container */
.steps-carousel {
    display: flex;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    gap: 1rem;
    padding: 0;
    flex-wrap: wrap;
    width: 100%;
    height: auto;

}

.service-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    width: 100vw;
    height: auto;
    scroll-snap-align: center;
    overflow: hidden;
    justify-content: space-between;
}

.service-info {
    position: relative;
    color: #fff;
    text-align: center;
    padding: 1rem;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 200px;

    /* Flexbox for centering */
    display: flex;
    flex-direction: column;
    justify-content: center; /* Vertically centers the content */
    align-items: center;     /* Horizontally centers the content */
}


.service-title {
    font-size: 2rem;
    font-weight: 700;
    letter-spacing: 1px;
    margin-top: 0px;
    margin-bottom: 0; /* Reset bottom margin */
    padding: 0; /* Ensure no extra padding */
    text-transform: uppercase;
    color: #f5f5f5;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.6);
}



.service-description {
    font-size: 1.2rem;
    font-weight: 400;
    color: #f0f0f0;
    line-height: 1.6;
    max-width: 90%;
    margin: 0; /* Reset margin */
    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
}



.video-wrapper {
    position: relative;
    width: 100%;
    /* Allow height to be based on the content (video) */
}


@keyframes fadeIn {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (min-width: 768px) {
    .steps-carousel {
        flex-direction: row;
        /* Side by side videos on desktop */
    }
}

.step {
    flex: 0 0 100vw;
    /* Ensure each step takes up full viewport width */
    scroll-snap-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 1rem;
    /* Padding inside the step */
}


video {
    width: 100%;
    height: auto;
    object-fit: cover;
    transition: opacity 0.5s ease, transform 0.5s ease;
}


video {
    width: 100%;
    height: auto;
    object-fit: cover;
    transition: opacity 0.5s ease, transform 0.5s ease;
    /* Smooth fade-in and scale */
    /* Ensures the video takes up the whole container */
}

.video-container {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
}

.mobile-divider {
    display: none;
    border: none;
    border-top: 2px solid #ccc;
    /* Thicker border for visibility */
    width: 90%;
    height: 5px;
    margin: 20px auto;
    /* Add margin to create space around the divider */
}


@media (min-width: 1024px) {
    .service-section {
        flex: 1;
        min-width: 20.33%;
        /* Make each service take up 1/3 of the screen */
        /* Keep the height consistent */
    }

    .video-container {
        /* Smaller video height for mobile */
    }

    video {
        object-fit: contain;
        /* Ensure full video is visible */
    }
}

@media (min-width: 1400px) {
    .service-section {
        flex: 1;
        min-width: 20.33%;
        /* Make each service take up 1/3 of the screen */
        /* Keep the height consistent */
    }

    .video-container {
        /* Smaller video height for mobile */
    }

    video {
        object-fit: contain;
        /* Ensure full video is visible */
    }
}

@media (min-width: 1600px) {
    .service-section {
        flex: 1;
        min-width: 20.33%;
        /* Make each service take up 1/3 of the screen */
        /* Keep the height consistent */
    }

    .video-container {
        /* Smaller video height for mobile */
    }

    video {
        object-fit: contain;
        /* Ensure full video is visible */
    }
}


/* Tablet View: Videos stack two per row */
@media (min-width: 768px) and (max-width: 1023px) {
    .service-section {
        flex: 1;
        min-width: 70%;
        /* Two videos per row on tablets */
    }

    .video-container {

        /* Smaller video height for mobile */
    }

    video {
        object-fit: contain;
        /* Ensure full video is visible */
    }

    .mobile-divider {
        display: block;
        margin-top: 2rem;
        /* Ensure there's space above */
        margin-bottom: 2rem;
        /* Ensure there's space below */
    }
}

/* Mobile View: Videos stack vertically */
@media (max-width: 767px) {
    .service-section {
        width: 100%;
        min-width: 90%;
        /* One video per row on mobile */
        height: auto;
        /* Adjust height to maintain aspect ratio */
    }

    .video-container {
        /* Smaller video height for mobile */
    }

    video {
        object-fit: contain;
        /* Ensure full video is visible */
    }

    .mobile-divider {
        display: block;
        margin-top: 2rem;
        /* Ensure there's space above */
        margin-bottom: 2rem;
        /* Ensure there's space below */
    }
}


.step-number {
    background-color: white;
    color: #000;
    font-size: 2.5em;
    font-weight: bold;
    padding: 10px;
    width: 60px;
    height: 60px;
    line-height: 40px;
    margin: 0 auto 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    border-bottom: 10px solid black;
}

.hero {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    color: white;
    padding: 100px 20px;
    background-image: linear-gradient(rgba(27, 27, 27, 0.8), rgba(27, 27, 27, 0.8)), url('@/assets/hero-bg.png');
    background-size: cover;
    background-position: center;
    opacity: 0.9;
}

.hero h1 {
    margin-bottom: 20px;
    font-family: 'Bebas Neue', sans-serif;
    font-size: 4rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #C49B63;
    /* Gold for luxury */
    text-shadow: 6px 6px 9px rgba(0, 0, 0, 0.9);
}

.hero p {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 1.5rem;
    letter-spacing: 0.05em;
    color: #F5F5F5;
    /* Off-white for contrast */
    text-shadow: 4px 4px 7px rgba(0, 0, 0, 0.8);
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes slideUp {
    0% {
        transform: translateY(20px);
    }

    100% {
        transform: translateY(0);
    }
}

/* Heading animation: fade-in and slide-up */
.fade-in-slide-up {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 4rem;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5);
    opacity: 0;
    animation: fadeIn 1s ease-in-out forwards, slideUp 1s ease-in-out forwards;
    animation-delay: 0.2s;
    /* Delay for the animation */
}

/* Paragraph animation: fade-in */
.fade-in {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 1.5rem;
    color: white;
    letter-spacing: 0.05em;
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
    opacity: 0;
    animation: fadeIn 2s ease-in-out forwards;
    animation-delay: 0.8s;
    /* Delay for the paragraph to appear */
}

.btn-primary {
    background-color: #C49B63;
    /* Luxurious gold */
    color: #1B1B1B;
    /* Dark charcoal text */
    padding: 12px 24px;
    border: none;
    cursor: pointer;
    font-weight: bold;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
}

.btn-primary:hover {
    background-color: #B0884A;
    /* Darker gold on hover */
}

.btn-secondary {
    background-color: #1A2A4B;
    /* Deep navy blue */
    color: #FFFFFF;
    /* White text */
    padding: 12px 24px;
    border: none;
    cursor: pointer;
    font-weight: bold;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.btn-secondary:hover {
    background-color: #16324F;
    /* Slightly lighter on hover */
}


/* Media Query for Mobile Devices */
@media screen and (max-width: 768px) {
    .hero {
        padding: 50px 10px;
        /* Reduce padding on mobile */
    }

    .hero h1 {
        font-size: 2em;
        /* Reduce the font size for the heading */
        margin-bottom: 15px;
    }

    .hero p {
        font-size: 1.2em;
        /* Reduce the font size for the paragraph */
        margin-bottom: 30px;
    }

    .btn-primary {
        padding: 8px 16px;
        /* Slightly reduce the button size */
        font-size: 1em;
        /* Adjust button text size */
    }
}

.featured-cars {
    /* background-color: #f9f3e9; */
    background-color: #F0F0F0;
    width: 100%;
    text-align: center;
}

.carousel {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    gap: 30px;
    /* justify-content: center; */

    height: 850px;
    width: 100%;
    padding: 0 60px;
    /* Adjust for left and right padding */
    box-sizing: border-box;
    position: relative;
}

.car-listing {
    flex: 0 0 200px;
    transition: transform 0.5s ease, opacity 0.5s ease;
    scroll-snap-align: center;
    transform-origin: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
}

.car-listing img {
    max-height: 500px;
    width: auto;
    border-radius: 8px;
}

.car-listing video {
    max-height: 500px;
    width: auto;
    border-radius: 8px;
}

.car-listing.active {
    transform: scale(1.2);
}

.car-listing.previous,
.car-listing.next {
    opacity: 0.7;
    /* Dim the neighboring car listings */
    transform: translateX(10px);
    /* Slightly move next/previous listings */
}

.car-listing.previous {
    transform: translateX(-10px);
    /* Move the left neighbor slightly to the left */
}

.car-listing.next {
    transform: translateX(10px);
    /* Move the right neighbor slightly to the right */
}

.car-listing:not(.active) {
    opacity: 0.5;
}

.btn-secondary {
    background-color: #1b1b1b;
    color: white;
    padding: 10px 20px;
    border: none;
    cursor: pointer;
    font-weight: 700;
}

/* Renting Made Easy Section */
.renting-steps {
    background-color: #1B1B1B;
    /* Dark background for contrast */
    padding: 50px 20px;
    color: #F5F5F5;
    /* Off-white text */
    text-align: center;
}

.renting-steps h2 {
    font-size: 2.5em;
    color: #C49B63;
    /* Gold for headings */
}

.renting-steps h3 {
    font-size: 1.5em;
    color: #F5F5F5;
}

/* The videos fade in */
.steps-carousel .step {
    opacity: 0;
    transform: translateY(50px);
    /* Start slightly off-screen */
    transition: opacity 0.6s ease, transform 0.6s ease;
}

.steps-carousel .step.active {
    opacity: 1;
    transform: translateY(0);
}

.steps {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 40px;
    text-align: left;
}

.step {
    flex: 0 0 100vw;
    scroll-snap-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 1rem;
}

.step-number {
    background-color: white;
    color: #000;
    font-size: 2.5em;
    font-weight: bold;
    padding: 10px;
    width: 60px;
    height: 60px;
    line-height: 40px;
    margin: 0 auto 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    border-bottom: 10px solid black;
}

.step h4 {
    font-size: 1.2em;
    margin-bottom: 15px;
    font-weight: 700;
}

.step p {
    font-size: 1em;
    line-height: 1.5;
}

/* Mobile Styles */
@media (max-width: 768px) {
    .steps-carousel {
        flex-direction: row;
        /* Keep row direction for horizontal scroll */
    }

    .step {
        width: 100vw;
        /* Full viewport width */
        margin: 0;
        /* Remove extra margin for full width display */
    }

    .step-number {
        font-size: 2em;
        width: 50px;
        height: 50px;
    }

    .step h4 {
        font-size: 1.1em;
    }

    .step p {
        font-size: 0.9em;
    }
}


.renting-steps-dreams {
    background-color: #1b1b1b;
    padding: 50px 20px;
    color: white;
    text-align: center;
    max-width: 100vw;
    /* Ensure the container doesn't exceed 100vw */
    overflow: hidden;
    /* Prevent horizontal overflow */
}

.renting-steps-dreams h2 {
    font-size: 2.5em;
    margin-bottom: 10px;
}

.renting-steps-dreams h3 {
    font-size: 1rem;
    transition: transform 0.5s ease, opacity 0.5s ease;
}

.steps-dreams {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 100%;
    /* Ensure the steps container doesn't exceed 100vw */
    margin: 0 auto;
}

.step-dreams {
    flex: 1 1 30%;
    /* Distribute each step-dreams evenly without exceeding 100vw */
    box-sizing: border-box;
    padding: 20px;
    max-width: 100%;
    /* Prevent each step from exceeding the container */
}

.step-number-dreams {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 10px;
}

@media (max-width: 768px) {
    .steps-dreams {
        flex-direction: column;
    }

    .step-dreams {
        flex: 1 1 100%;
        /* Each step takes full width on smaller screens */
        margin-bottom: 20px;
    }
}

/* Why Choose Us Section */
.why-choose-us {
    /* background-color: #F9F3E9; */
    background-color: #F0F0F0;
    /* Warm beige */
    padding: 50px 20px;
    color: #1B1B1B;
    /* Dark text */
}

.why-choose-us h2 {
    font-size: 2.5em;
    color: #C49B63;
    /* Gold */
    margin-bottom: 40px;
}

.benefits {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 40px;
    text-align: center;
}

.benefit {
    flex: 1;
    margin: 0 20px;
}

.benefit-icon {
    background-color: #C4A484;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    display: inline-block;
}

.benefit-icon img {
    max-width: 40px;
}

.benefit h4 {
    font-size: 1.2em;
    margin-bottom: 15px;
    font-weight: 700;
}

.benefit p {
    font-size: 1em;
    line-height: 1.5;
}

/* Media Query for Mobile Devices */
@media screen and (max-width: 768px) {
    .benefits {
        flex-direction: column;
        /* Stack elements vertically */
        align-items: center;
        /* Center align items */
    }

    .benefit {
        margin: 20px 0;
        /* Add margin around each benefit for spacing */
    }

    .why-choose-us h2 {
        font-size: 2em;
        /* Adjust font size for mobile screens */
    }
}

/* FAQ Section */
.faq-section {
    background-color: #f9f3e9;
    /* background-color: #F0F0F0; */
    padding: 50px 20px;
}

.faq-section h2 {
    font-size: 2em;
    margin-bottom: 40px;
    text-align: center;
    font-weight: 700;
}

.faq-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
}

.faq-item {
    border-bottom: 1px solid #ddd;
    padding: 15px 0;
    display: block;
    /* Ensure that each FAQ item is a block element */
    align-items: flex-start;
    /* Align items to start so they stack vertically */
}

.faq-question {
    display: flex;
    align-items: center;
    font-size: 1.2em;
    font-weight: 500;
    cursor: pointer;
    margin-bottom: 10px;
    /* Add margin to create space between question and answer */
}

.faq-toggle {
    font-size: 1.5em;
    font-weight: bold;
    color: #c49b63;
    margin-left: auto;
    transition: transform 0.3s ease;
}

.faq-toggle.active {
    transform: rotate(45deg);
}

.faq-number {
    font-size: 1.5em;
    font-weight: bold;
    color: #c49b63;
    margin-right: 10px;
    display: inline-block;
}


.faq-text {
    flex-grow: 1;
}

.faq-answer {
    display: block;
    overflow: hidden;
    height: auto;
    transition: opacity 0.4s ease, padding 0.4s ease;
    opacity: 1;
    padding-top: 10px;
    margin-left: 0;
    /* Ensure the answer appears directly below the question */
}

.faq-answer.enter-active,
.faq-answer.leave-active {
    transition: height 0.3s ease, opacity 0.3s ease, padding-top 0.3s ease;
}

.faq-answer.enter,
.faq-answer.leave-to {
    height: 0;
    opacity: 0;
    padding-top: 0;
}

.faq-answer.enter-to {
    height: auto;
    opacity: 1;
    padding-top: 10px;
}

.faq-item-even .faq-number,
.faq-item-odd .faq-number {
    order: 0;
    /* Remove the reordering */
    margin-left: 0;
    /* Remove left margin to ensure proper alignment */
    margin-right: 10px;
    /* Apply consistent spacing */
}


@media (max-width: 768px) {
    .faq-grid {
        grid-template-columns: 1fr;
        /* Stack items in a single column on mobile */
    }

    .faq-section {
        padding: 30px 15px;
    }

    .faq-section h2 {
        font-size: 1.5em;
        /* Smaller heading font size */
        margin-bottom: 20px;
    }

    .faq-item {
        padding: 10px 0;
    }

    .faq-question {
        font-size: 1.1em;
        /* Slightly smaller question font size */
    }

    .faq-toggle {
        font-size: 1.3em;
        /* Adjust the toggle size */
    }

    .faq-answer {
        font-size: 0.9em;
        /* Slightly smaller answer font size */
    }
}


.show-more-btn, .show-less-btn {
    display: block;
    margin: 20px auto;
    padding: 10px 20px;
    background-color: #c49b63;
    color: #fff;
    border: none;
    cursor: pointer;
    font-size: 1em;
    border-radius: 5px;
    transition: background-color 0.3s ease;
    font-weight: 700;
}

.show-more-btn:hover, .show-less-btn:hover {
    background-color: #a87d4e;
}
/* Slide Fade Transition */
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
    overflow: hidden;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active in <2.1.8 */
    {
    height: 0;
    opacity: 0;
    padding-top: 0;
}

.slide-fade-enter-to {
    height: auto;
    opacity: 1;
    padding-top: 10px;
}

.slide-fade-leave {
    opacity: 1;
    height: auto;
    padding-top: 15px;
    padding-bottom: 15px;
}


.currency-selector {
    padding: 20px;
    background-color: #F9F3E9;
    /* Warm beige */
    border-radius: 15px;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    margin: 0 auto;
    border: 2px solid #C49B63;
    /* Gold border */
}

.currency-label {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
}

.currency-dropdown {
    padding: 0.8rem 1.5rem;
    border-radius: 12px;
    background: linear-gradient(135deg, #fff, #e9ecef);
    font-size: 1.1rem;
    font-weight: 500;
    color: #333;
    border: 2px solid #C49B63;
    /* Gold border for dropdown */
    transition: all 0.3s ease;
    text-align: center;
}

.currency-dropdown {
    padding: 0.8rem 1.5rem;
    border-radius: 12px;
    border: 2px solid transparent;
    background: linear-gradient(135deg, #fff, #e9ecef);
    /* Soft gradient background */
    /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); */
    /* Subtle shadow for depth */
    font-size: 1.1rem;
    font-weight: 500;
    color: #333;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
    max-width: 300px;
    text-align: center;

    /* Custom arrow for select dropdown */
    appearance: none;
    background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="%23333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>');
    background-repeat: no-repeat;
    background-position: right 15px center;
    background-size: 16px;
}

.currency-dropdown:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 00 10px rgba(0, 123, 255, 0.5);
    /* Blue shadow on focus */
    background: linear-gradient(135deg, #fff, #dce4f6);
    /* Slight color shift on focus */
}

.currency-dropdown:hover {
    border-color: #007bff;
}

.currency-dropdown:active {
    background-color: #f0f0f0;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    /* Subtle inset shadow */
}

/* Option Styling */
.currency-dropdown option {
    padding: 10px;
    background-color: #fff;
    color: #333;
    font-size: 1rem;
}


/* Floating WhatsApp Button Styles */
.floating-whatsapp {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #075E54; /* Darker shade of WhatsApp green */
  color: white;
  padding: 10px 20px;
  border-radius: 50px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  font-size: 16px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Hover effect */
.floating-whatsapp:hover {
  background-color: #054C44; /* Even darker shade of WhatsApp green */
}

#custom-typing-animation {
  /* font-family: monospace; */
  white-space: nowrap;
  overflow: hidden;
  border-right: 3px solid black;
  display: inline-block;
  letter-spacing: 0; 
}

.blinking-caret {
  animation: blink 0.75s step-end infinite;
}

@keyframes blink {
  50% {
    border-color: transparent;
  }
}


</style>